import { useMemo } from 'react'

import { useFacilityTourPlanCheckPointsQuery } from '@/graphql/generated/hooks'

import { mapTourPlanCheckpoints } from '../../utils/mappedFacilityData'

export const useTourPlanCheckpoints = (id: string) => {
  const { data, loading: isLoading } = useFacilityTourPlanCheckPointsQuery({
    fetchPolicy: 'network-only',
    variables: {
      id,
    },
  })

  const checkpoints = useMemo(
    () => mapTourPlanCheckpoints(data?.tourPlan),
    [data, isLoading]
  )

  return {
    id,
    name: data?.tourPlan?.name,
    checkpoints: checkpoints,
    isLoading,
  }
}
